import { render, staticRenderFns } from "./VitalSign.vue?vue&type=template&id=f99e7f6c&scoped=true&"
import script from "./VitalSign.vue?vue&type=script&lang=js&"
export * from "./VitalSign.vue?vue&type=script&lang=js&"
import style0 from "./VitalSign.vue?vue&type=style&index=0&id=f99e7f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99e7f6c",
  null
  
)

export default component.exports